<div class="cart_item">
  <div class="cart_item_wrapper">
    <div class="cart_item_heading">
      <i class="ico-rail"></i>&nbsp;
      <span id="outbound_Train_Journey"
        >{{ outboundJourney.from }} <span i18n="@@to">to</span> {{ outboundJourney.to }}</span
      >
    </div>
    @if (outboundFare.identifiers?.isSplit) {
      <app-split-ticket-icon></app-split-ticket-icon>
    }
    <strong [ngClass]="outboundFare.identifiers?.isSplit ? 'ticket-name-split' : 'ticket-name'">{{
      outboundFare.type
    }}</strong>
    @if (outboundFare.identifiers?.isSplit && outboundFare.identifiers?.fares?.length) {
      <app-split-ticket-panel
        [showType]="true"
        [type]="outboundFare.type"
        [isSplit]="outboundFare.identifiers?.isSplit"
        [fares]="outboundFare.identifiers?.fares"
      >
      </app-split-ticket-panel>
    }
    <div class="cart_item_operator">
      <span i18n="@@basketPanelOperatorRail">Operator:</span>&nbsp;
      <strong>{{ getRailOperators(outboundJourney.journeyLegs) }}</strong>
    </div>
    <div class="cart_item_rail_ticket_times">
      <span i18n="@@basketPanelDepartureDateRail">Date:</span>&nbsp;
      <strong
        >{{ outboundJourney.departDateTime | sabsDate: 1 }}
        <span>
          {{ outboundJourney.departDateTime | sabsTimePipe: 'timeString' }}
        </span>
      </strong>
    </div>
    <div class="cart_item_view_conditions">
      <a
        (click)="openRailTicketDetailsDialog(outboundJourney, outboundFare)"
        i18n="@@railViewConditions"
        id="outbound_View_Conditions"
        class="view_conditions"
        >View Conditions</a
      >
      <a
        (click)="openDetailsModal(outboundJourney)"
        i18n="@@railJourneyDetails"
        id="outbound_View_details"
        class="view_conditions"
        >Journey Details</a
      >
    </div>
    @if (inboundJourney && inboundFare) {
      <div class="cart_item_heading">
        <i class="ico-rail"></i>&nbsp;
        <span id="inbound_Train_Journey"
          >{{ inboundJourney.from }} <span i18n="@@to">to</span> {{ inboundJourney.to }}</span
        >
      </div>
      @if (inboundFare.identifiers?.isSplit) {
        <app-split-ticket-icon></app-split-ticket-icon>
      }
      <strong [ngClass]="inboundFare.identifiers?.isSplit ? 'ticket-name-split' : 'ticket-name'">{{
        inboundFare.type
      }}</strong>
      @if (inboundFare.identifiers?.isSplit && inboundFare.identifiers?.fares?.length) {
        <app-split-ticket-panel
          [showType]="true"
          [isSplit]="inboundFare.identifiers?.isSplit"
          [fares]="inboundFare.identifiers?.fares"
        >
        </app-split-ticket-panel>
      }
      <div class="cart_item_operator">
        <span i18n="@@basketPanelOperatorRail">Operator:</span>&nbsp;
        <strong>{{ getRailOperators(inboundJourney.journeyLegs) }}</strong>
      </div>
      <div class="cart_item_rail_ticket_times">
        <span i18n="@@basketPanelDepartureDateRail">Date:</span>&nbsp;
        <strong
          >{{ inboundJourney.departDateTime | sabsDate: 1 }}
          <span>
            {{ inboundJourney.departDateTime | sabsTimePipe: 'timeString' }}
          </span>
        </strong>
      </div>
      <div class="cart_item_view_conditions">
        <a
          (click)="openRailTicketDetailsDialog(inboundJourney, inboundFare)"
          i18n="@@railViewConditions"
          id="inbound_View_Conditions"
          class="view_conditions"
          >View Conditions</a
        >
        <a
          (click)="openDetailsModal(inboundJourney)"
          i18n="@@railJourneyDetails"
          id="inbound_View_Details"
          class="view_conditions"
          >Journey Details</a
        >
      </div>
    }
  </div>
</div>
